/*
 * AgeValidationModal Messages
 *
 * This contains all the text for the AgeValidationModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.AgeValidationModalIsOfAge.title',
    defaultMessage: '¿Sos mayor de edad?',
  },
  acceptButton: {
    id: 'app.components.AgeValidationModalIsOfAge.acceptButton',
    defaultMessage: 'Soy mayor',
  },
  cancelButton: {
    id: 'app.components.AgeValidationModalIsOfAge.cancelButton',
    defaultMessage: 'Soy menor',
  },
});
